/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * INssProductFeatureGrid contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export interface INssProductFeatureGridConfig extends Msdyn365.IModuleConfig {
    global?: IGlobalData;
    layout?: ILayoutData;
    content?: IContentData[];
}

export interface IGlobalData {
    fontColor?: string;
    fontFamily?: string;
    backgroundImage?: Msdyn365.IImageData;
    backgroundColor?: string;
    link?: ILinkData;
}

export interface ILayoutData {
    height?: number;
    columnCount?: number;
}

export interface IContentData {
    heading?: IHeadingData;
    subHeading?: ISubHeadingData;
    description?: IDescriptionData;
    button?: IButtonData;
    backgroundColor?: string;
    foregroundImage?: Msdyn365.IImageData;
    layout?: ILayoutData;
}

export interface ILinkData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export const enum HeadingSize {
    xxl = 'xxl',
    xl = 'xl',
    l = 'l',
    m = 'm',
    s = 's',
    xs = 'xs',
    xxs = 'xxs'
}

export const enum HeadingTextAlign {
    left = 'left',
    center = 'center',
    right = 'right'
}

export interface IHeadingData {
    text?: string;
    bold?: boolean;
    italics?: boolean;
    underline?: boolean;
    size?: HeadingSize;
    fontFamily?: string;
    fontColor?: string;
    textAlign?: HeadingTextAlign;
    lineHeight?: number;
    letterSpacing?: number;
}

export const enum SubHeadingSize {
    xxl = 'xxl',
    xl = 'xl',
    l = 'l',
    m = 'm',
    s = 's',
    xs = 'xs',
    xxs = 'xxs'
}

export const enum SubHeadingTextAlign {
    left = 'left',
    center = 'center',
    right = 'right'
}

export interface ISubHeadingData {
    text?: string;
    bold?: boolean;
    italics?: boolean;
    underline?: boolean;
    size?: SubHeadingSize;
    fontFamily?: string;
    fontColor?: string;
    textAlign?: SubHeadingTextAlign;
    lineHeight?: number;
    letterSpacing?: number;
}

export const enum DescriptionSize {
    xxl = 'xxl',
    xl = 'xl',
    l = 'l',
    m = 'm',
    s = 's',
    xs = 'xs',
    xxs = 'xxs'
}

export const enum DescriptionTextAlign {
    left = 'left',
    center = 'center',
    right = 'right'
}

export interface IDescriptionData {
    text?: Msdyn365.RichText;
    bold?: boolean;
    italics?: boolean;
    underline?: boolean;
    size?: DescriptionSize;
    fontFamily?: string;
    fontColor?: string;
    textAlign?: DescriptionTextAlign;
    lineHeight?: number;
    letterSpacing?: number;
}

export const enum ButtonSize {
    xxl = 'xxl',
    xl = 'xl',
    l = 'l',
    m = 'm',
    s = 's',
    xs = 'xs',
    xxs = 'xxs'
}

export const enum ButtonAlignSelf {
    start = 'start',
    center = 'center',
    end = 'end'
}

export interface IButtonData {
    text?: string;
    bold?: boolean;
    italics?: boolean;
    underline?: boolean;
    size?: ButtonSize;
    fontFamily?: string;
    fontColor?: string;
    lineHeight?: number;
    letterSpacing?: number;
    backgroundColor?: string;
    link?: ILinkData;
    alignSelf?: ButtonAlignSelf;
}

export const enum LayoutAnchor {
    nw = 'nw',
    n = 'n',
    ne = 'ne',
    w = 'w',
    c = 'c',
    e = 'e',
    sw = 'sw',
    s = 's',
    se = 'se'
}

export const enum LayoutFlexDirection {
    row = 'row',
    rowReverse = 'rowReverse',
    column = 'column',
    columnReverse = 'columnReverse'
}

export const enum LayoutAlignItems {
    start = 'start',
    center = 'center',
    end = 'end'
}

export const enum LayoutJustifyContent {
    start = 'start',
    spaceBetween = 'spaceBetween',
    spaceAround = 'spaceAround',
    center = 'center',
    end = 'end'
}

export interface ILayoutData {
    width?: number;
    height?: number;
    zIndex?: number;
    anchor?: LayoutAnchor;
    padding?: string;
    flexDirection?: LayoutFlexDirection;
    alignItems?: LayoutAlignItems;
    justifyContent?: LayoutJustifyContent;
}

export interface ILinkData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface INssProductFeatureGridProps<T> extends Msdyn365.IModule<T> {
    config: INssProductFeatureGridConfig;
}
